module.exports = __webpack_public_path__ + "static/6.63fd353f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/6.jpg
// module id = 443
// module chunks = 246384609461072